import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, SubCard, SubCardContainer, SubCardTitle, SessionsContainer, RightAlignedButton } from "../../common_components/Layout";
import { SessionStat } from "../../common_components/Analytics";
import { PrimaryButton } from "../../common_components/Buttons";


// Api Calls
import MissionAPI from "../../../api/api_calls/MissionAPI";


function CompletedSurveyResponsesCard(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingEvents, setLoadingEvents] = useState(true);
    const [goalCount, setGoalCount] = useState(-1);
    const [timezone, setTimezone] = useState("");

    const [surveyResponseCount, setSurveyResponseCount] = useState(-1);
    const [goalResponses, setGoalResponses] = useState(-1);
    const [passingScreenerResponses, setPassingScreenerResponses] = useState(-1);
    const [totalScreenerResponses, setTotalScreenerResponses] = useState(-1);
    const [loadingResponses, setLoadingResponses] = useState(true);


    useEffect(() => {
        async function getCompletedSessionsAndStats() {
            const result = await MissionAPI.showSurveyResponses({ missionId, navigate });

            if (result.success) {
                setSurveyResponseCount(result.survey_responses_count)
                setGoalResponses(result.mission.num_total_spots)
                if (result.total_screener_responses_count > 0) {
                    setPassingScreenerResponses(result.passing_screener_responses_count)
                    setTotalScreenerResponses(result.total_screener_responses_count)
                }

                setLoadingResponses(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getCompletedSessionsAndStats();
    }, []);

    return (
        <Card>
            <GrayCardTitle title="Survey Responses" />
            <SubCardContainer>
                <SubCard loading={loadingResponses}>
                    <SubCardTitle>
                        Survey Stats
                    </SubCardTitle>
                    <div className="session-stats-container">
                        <SessionStat title="Completions" primaryFill={surveyResponseCount} goalValue={goalResponses} legendText={surveyResponseCount + " of " + goalResponses} />
                        {totalScreenerResponses > 0 ? <SessionStat title="Screener Pass Rate" primaryFill={passingScreenerResponses} goalValue={totalScreenerResponses} legendText={Math.round(passingScreenerResponses * 1.0 / totalScreenerResponses * 100) + "%"} /> : <></>}

                    </div>
                    <RightAlignedButton>
                        <PrimaryButton onClick={() => navigate("/missions/" + missionId + "/responses")} text="View all" submitLoading={props.submitLoading} />
                    </RightAlignedButton>


                </SubCard>
            </SubCardContainer>
        </Card>

    )
}



export default CompletedSurveyResponsesCard;